import LoaderGlobalMetric from './LoaderGlobalMetric';

export default LoaderGlobalMetric;
